/**
 * Plugin Nuxt untuk logging error runtime di level aplikasi.
 *
 * Plugin ini belum melakukan reporting ke layanan eksternal.
 * Saat ini fungsinya adalah menyatukan titik logging untuk:
 * - error Vue
 * - error aplikasi Nuxt
 * - global Vue error handler
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vue:error", (..._args) => {
    console.error("vue:error");

    if (import.meta.client) {
      console.error(..._args);
    }
  });

  nuxtApp.hook("app:error", (..._args) => {
    console.error("app:error");

    if (import.meta.client) {
      console.error(..._args);
    }
  });

  nuxtApp.vueApp.config.errorHandler = (..._args) => {
    console.error("global error handler");

    if (import.meta.client) {
      console.error(..._args);
    }
  };
});
